app.directive('slWishlistButton', [
  '$rootScope',
  function ($rootScope) {
    return {
      restrict: 'E',
      scope: {
        getTargetWishlistItem: '&',
        product: '=',
        variationSelected: '=',
        wishlistItem: '=',
        isItemInWishlist: '=',
      },
      link: function ($scope) {
        function updateView() {
          $scope.isItemInWishlist = checkIsWishlistItemActive();
        }

        var checkIsWishlistItemActive = function () {
          if (!$rootScope.isUserLoggedIn) {
            return false;
          }

          return !_.isEmpty($scope.wishlistItem);
        };

        if ($scope.product.variations.length > 0) {
          $scope.$watch('variationSelected', function () {
            $scope.getTargetWishlistItem();
          });
        } else {
          $scope.getTargetWishlistItem();
        }

        $scope.$watch('wishlistItem', updateView);
      },
    };
  },
]);
